import React from 'react'

// import imgVegard from '../images/vegard.svg'
import imgStian from '../images/stian.svg'
import imgTor from '../images/tor.svg'
import imgMagne from '../images/magne.svg'
import imgEspen from '../images/espen.svg'
import imgJim from '../images/jim.svg'
import imgTormod from '../images/tormod.svg'
import imgEskil from '../images/eskil.svg'
import imgAasmund from '../images/aasmund.png'

export default [
  {
    id: 'tor',
    image: imgTor,
    name: 'Tor Ivar Johansen',
    title: 'Systemutvikler og daglig leder',
    phone: '+4748261953',
    email: 'tor@appresso.no',
    description: (
        <p>
        Full-stack programmerer utdannet ved Universitetet i Oslo, med en stor lidenskap for Python og Django.
        Tor er ekstra opptatt av teknologi og metoder som øker levetid, kvalitet og stabilitet for programmer.
        I tillegg har han den stilige tittelen CEO, som altså betyr at han er daglig leder i Appresso.
        </p>
    ),
  },
  {
    id: 'espen',
    image: imgEspen,
    name: 'Espen Angell Kristiansen',
    title: 'CTO - Systemutvikler',
    phone: '+4797658385',
    email: 'espen@appresso.no',
    description: (
      <p>
      Når det kommer til Espen så dekker ikke begrepet "full-stack utvikler" godt nok.
      Maken til kunnskap om det tekniske ved internett skal du lete lenge etter.
      Vi har til gode å finne en utfordring som Espen ikke klarer å finne en løsning for,
      og det er derfor han er CTO (teknisk sjef) hos oss.
      Espen er ekstra opptatt av modulariserbarhet og sikkerhet.
      Han er utdannet ved Institutt for Informatikk ved Universitetet i Oslo.
      </p>
    ),
  },
  {
    id: 'eskil',
    image: imgEskil,
    name: 'Eskil Nordland',
    title: 'Systemutvikler',
    description: (
      <p>
        Utdannet ved Institutt for informatikk ved Universitetet i Oslo.
        Eskil tar alt av utvikling både i Python og andre språk, og er ekstra
        opptatt av nettverksteknologi. Han jobber med hele webstacken,
        med fokus på Django, JavaScript og implementasjon av design i CSS.
      </p>
    ),
  },
  {
    id: 'magne',
    image: imgMagne,
    name: 'Magne Westlie',
    title: '',
    phone: '+4793492558',
    email: 'magne@appresso.no',
    description: (
      <p>
      Medeier og partner med utdanning fra Institutt for Informatikk ved Universitetet i Oslo.
      Før informatikkstudiene jobbet Magne som Automasjonsmekaniker, og han jobbet tidligere med
      vedlikehold og implementasjon av produksjonssystemer ved hjelp av PLS og Pneumatikk i industrien.
      Magne synes programmering er veldig gøy, og han streber alltid etter å
      gjøre de kompliserte tingene så enkelt som mulig for kundene og brukerne.
      </p>
    ),
  },
  // {
  //   id: 'vegard',
  //   image: imgVegard,
  //   name: 'Vegard Angell',
  //   title: 'Systemutvikler og javascript (React/Angular) ekspert',
  //   description: (
  //     <p>
  //     Vegard har sin utdannelse fra Institutt for informatikk ved Universitetet i Oslo.
  //     Han er vår store ekspert på alt som har med JavaScript å gjøre.
  //     Han nøyer seg ikke med å programmere JavaScript, men går også inn i selve
  //     språket eller motoren og gjør endringer når det trengs.
  //     Han har studert nøye hvordan støtte for funksjonalitet er i
  //     forskjellige nettlesere og vet hva som fungerer eller ikke fungerer.
  //     </p>
  //   ),
  // },
  {
    id: 'stian',
    image: imgStian,
    name: 'Stian Julseth',
    title: 'Systemutvikler',
    description: (
      <p>
        Stian jobber med hele webstacken, og har sin utdannelse fra Institutt for informatikk ved Universitetet i Oslo.
        Han har imponerende kunnskap om Python og Django, og det finnes ikke den oppgaven han ikke tar på strak arm.
        Stian er også veldig god i JavaScript og implementasjon av design i CSS.
      </p>
    ),
  },
  {
    id: 'jim',
    image: imgJim,
    name: 'Jim Nordal',
    title: 'Systemutvikler',
    description: (
      <p>
        Jim har sin utdannelse som systemutvikler fra Høgskolen i Østfold. Han er en grundig og organisert fyr,
        og derfor har han som hovedansvar prosjektledelse, testing og QA.
        Jim er opptatt av kvalitet og levetid på systemer, og i tillegg driver han
        med backend-koding på flere av våre prosjekter.
      </p>
    ),
  },
  {
    id: 'tormod',
    image: imgTormod,
    name: 'Tormod Kasbo',
    title: 'Kontorsjef',
    description: (
      <p>
        Tormod er vår kontorsjef. Han passer på at det er orden i sakene, og
        hjelper til der det trengs.
      </p>
    ),
  },
  {
    id: 'aasmund',
    image: imgAasmund,
    name: 'Åsmund Rosendahl',
    title: 'Systemutvikler deltid',
    description: (
      <p>
        Åsmund er full-stack utvikler med utdannelse fra Institutt for Informatikk ved Universitetet i Oslo,
        og har studert nettverk, rendering og optimalisering. Han er en grundig og svært systematisk
        når han programmerer med Java, C og Python og React. Under siste del av arbeidet med sin Mastergrad
        arbeider han deltid hos oss i Appresso.
      </p>
    ),
  },
]



// WEBPACK FOOTER //
// ./src/data/employees.js